import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralProfilePicture = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "single-neutral-profile-picture" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 2.25,
			y: .75,
			width: 19.5,
			height: 22.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 12,
			cy: 9.083,
			r: 4.11
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.75,19.027a7.63,7.63,0,0,0-13.5,0"
		})
	]
});
export default SvgSingleNeutralProfilePicture;
